import React from 'react'
import { withModal } from '../'

class Switch extends React.Component {
  render() {
    return React.Children.map(this.props.children, child => {
      return child.props.path === this.props.modal.current ? child : null
    })
  }
}

export default withModal(Switch)
